import React from 'react';
import { Link } from 'react-router-dom';
import { BUSINESS, NAV_LINKS } from '../../data/siteData';

export default function Footer() {
  return (
    <footer style={{ background: 'var(--navy)', color: 'var(--silver)', padding: '4rem 2rem 2rem' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '3rem',
          marginBottom: '3rem',
        }}>
          {/* Brand */}
          <div>
            <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none', marginBottom: '1rem' }}>
              <div style={{
                width: 40, height: 40, background: 'var(--orange)', borderRadius: 6,
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.4rem',
              }}>🔧</div>
              <div style={{ lineHeight: 1 }}>
                <span style={{ display: 'block', fontFamily: '"Bebas Neue"', fontSize: '1.25rem', color: 'white', letterSpacing: '0.05em' }}>Brantford Auto</span>
                <span style={{ fontFamily: '"Barlow Condensed"', fontSize: '0.7rem', color: 'var(--silver)', letterSpacing: '0.12em', textTransform: 'uppercase' }}>Wrecking & Salvage</span>
              </div>
            </Link>
            <p style={{ fontSize: '0.88rem', lineHeight: 1.7, color: 'var(--silver)', marginBottom: '1.5rem', maxWidth: 280 }}>
              Quality used auto parts, vehicle recycling, and scrap car removal serving Brantford, Paris, and Brant County since 2000.
            </p>
            <div style={{ display: 'flex', gap: '0.75rem' }}>
              {[
                { href: BUSINESS.social.facebook, label: 'f', title: 'Facebook' },
                { href: BUSINESS.social.instagram, label: '📷', title: 'Instagram' },
                { href: BUSINESS.social.google, label: 'G', title: 'Google' },
              ].map(s => (
                <a key={s.title} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.title}
                  style={{
                    width: 36, height: 36, background: 'rgba(255,255,255,0.08)', borderRadius: 8,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    textDecoration: 'none', fontSize: '0.9rem', color: 'var(--silver)',
                    transition: 'background 0.2s, color 0.2s', fontFamily: '"Bebas Neue"',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background = 'var(--orange)'; e.currentTarget.style.color = 'white'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; e.currentTarget.style.color = 'var(--silver)'; }}
                >{s.label}</a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ fontFamily: '"Barlow Condensed"', fontSize: '0.8rem', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'white', marginBottom: '1.25rem' }}>
              Quick Links
            </h4>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
              {NAV_LINKS.map(l => (
                <li key={l.label}>
                  <Link to={l.href.startsWith('/#') ? '/' : l.href}
                    style={{ textDecoration: 'none', color: 'var(--silver)', fontSize: '0.88rem', transition: 'color 0.2s' }}
                    onMouseEnter={e => e.target.style.color = 'white'}
                    onMouseLeave={e => e.target.style.color = 'var(--silver)'}
                  >{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 style={{ fontFamily: '"Barlow Condensed"', fontSize: '0.8rem', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'white', marginBottom: '1.25rem' }}>
              Services
            </h4>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
              {['Used Parts Sales', 'Vehicle Recycling', 'Scrap Car Removal', 'Parts Locator'].map(s => (
                <li key={s}>
                  <Link to="/contact" style={{ textDecoration: 'none', color: 'var(--silver)', fontSize: '0.88rem', transition: 'color 0.2s' }}
                    onMouseEnter={e => e.target.style.color = 'white'}
                    onMouseLeave={e => e.target.style.color = 'var(--silver)'}
                  >{s}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontFamily: '"Barlow Condensed"', fontSize: '0.8rem', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'white', marginBottom: '1.25rem' }}>
              Contact
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
              <a href={`tel:${BUSINESS.phoneRaw}`} style={{ color: 'var(--silver)', textDecoration: 'none', fontSize: '0.88rem' }}>{BUSINESS.phone}</a>
              <span style={{ color: 'var(--silver)', fontSize: '0.88rem' }}>{BUSINESS.address.street}</span>
              <span style={{ color: 'var(--silver)', fontSize: '0.88rem' }}>{BUSINESS.address.city}, {BUSINESS.address.province} {BUSINESS.address.postal}</span>
              <span style={{ color: 'var(--text-light)', fontSize: '0.85rem', marginTop: '0.25rem' }}>Mon–Fri: 8am–5pm</span>
              <span style={{ color: 'var(--text-light)', fontSize: '0.85rem' }}>Sat: 9am–3pm</span>
              <span style={{ color: 'var(--text-light)', fontSize: '0.85rem' }}>Sun: Closed</span>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          paddingTop: '2rem',
          borderTop: '1px solid rgba(255,255,255,0.08)',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          flexWrap: 'wrap', gap: '1rem',
        }}>
          <p style={{ fontSize: '0.8rem', color: 'var(--text-light)' }}>
            © {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.
          </p>
          <p style={{ fontSize: '0.8rem', color: 'var(--text-light)' }}>
            Proudly serving Brantford, Paris, Cambridge & Brant County, Ontario
          </p>
          <p style={{ fontSize: '0.8rem', color: 'var(--text-light)' }}>
            Designed and Developed by <a href="https://reklam.ca" target="_blank" rel="noopener noreferrer"
              style={{ color: 'var(--silver)', textDecoration: 'none', transition: 'color 0.2s' }}
              onMouseEnter={e => e.target.style.color = 'white'}
              onMouseLeave={e => e.target.style.color = 'var(--silver)'}
            >Reklam.ca</a>
          </p>
        </div>
      </div>
    </footer>
  );
}